import React, { useEffect, useState } from "react";
import axios from "../../api/axios";
import Navbar from "../navsidebar/navbar";
import Sidebar from "../navsidebar/sidebar";

const RetailTopitem = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const storedData = JSON.parse(sessionStorage.getItem("userData"));
    
        
    

  if (storedData.business_type == 'G'){
    const businessid = sessionStorage.getItem('configBizEntityId')
    var businessEntityId = businessid;
  }else{
    
    var businessEntityId = storedData.businessEntityId;

  sessionStorage.setItem("configBizEntityId",businessEntityId);
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`retail/getTodayTopItems/${businessEntityId}`);
        setData(response.data);
        setLoading(false);
      } catch (err) {
        setError("Failed to load data");
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <p className="text-center mt-4">Loading...</p>;
  if (error) return <p className="text-center text-danger mt-4">{error}</p>;

  return (
    <div className="d-flex h-100">
     
    <Sidebar />
     <div className="d-flex flex-column w-100">
     <Navbar />
    <div className="container-fluid p-4">
      <div className="table-responsive">
        <table className="table table-bordered table-hover shadow-sm">
          <thead className="table-light">
            <tr>
              <th className="py-3">Item Name</th>
              <th className="py-3">Quantity Sold</th>
              <th className="py-3">Total Sales (₹)</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td className="py-3">{item.item_name}</td>
                <td className="py-3">{item.total_quantity_sold}</td>
                <td className="py-3">₹{item.total_sales_amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
    </div>
    </div>
  );
};

export default RetailTopitem;
